import './button.css';  // TMP


export class Button{
    constructor(id, label, type){
        var _button,
            _id = id,
            _label = label,
            _type = type || 'button', // reset, submit
            _clickEventHandlers = []
        ; 

        Object.defineProperty(this,'id',{
            get : function(){ return _id },
        });
        
        Object.defineProperty(this,'type',{
            get : function(){ _type = type }
        });
        
        Object.defineProperty(this,'label',{
            get : function(){ return _label }
        });


        Object.defineProperty(this,'button',{
            get : function(){ return _button },
            set : function(b){ _button = b }
        });

        Object.defineProperty(this,'clickEventHandlers',{
            get : function(){ return _clickEventHandlers }
        })

        // init 
        this.init();

    }


    // =======
    // getters
    // -------
    getId(){ return this.id }

    getClickEventHandlers(){
        return this.clickEventHandlers;
    }

    getButton(){ return this.button }

    // ====
    // init
    // ----
    init(){
        var button = this.createButton();
        this.setButton(button);
        this.setButtonListeners();
    }

    // ========================
    // interface implementation
    // -------------------------
    getDOMNode(){
        return this.button;
    }

    getCurrentValue(){
        var button = this.getButton();
        return Button.getDataObject(button);
    }



    // =========
    // modifiers
    // ---------


    setButton(b){ this.button = b }

    createButton(){
        var button = document.createElement('button');
        button.setAttribute('id',this.getId());
        button.setAttribute('class','button')
        button.setAttribute('type', 'button' );
        button.innerText = this.label;
        return button; 
    }

    // =====
    // utils
    // -----
    static setDataObject(node, object){
        node.data = object  // TMP 
    }

    static getDataObject(node){
        return node.data; // TMP 
    } 

    // =========
    // listeners
    // ---------
    setButtonListeners(){
        var clickableButton = this.getDOMNode();
        clickableButton.addEventListener('click',this.eventRouter.bind(this));
    }

    eventRouter(e){
        switch(e.type){
            case 'click':
                if (e.target) this.onClick(e);
                break;
        }
    }

    onClick(e){
        var button = this.getButton();
        var object = Button.getDataObject(button);
        var array = this.getClickEventHandlers();
        if (array.length)  array.forEach(handler => handler(object));
    }

    // ======
    // public
    // ------
    addClickEventHandler(handler){
        var button = this.getButton();
        var object = Button.getDataObject(button);
        var array = this.getClickEventHandlers(object);
        array.push(handler)

    } 

    setDefaultValue(object){
        var button = this.getButton();
        Button.setDataObject(button, object);
    }

}
